import $ from "jquery";

$(document).ready(function () {
    let newEl;
    var activeEl = document.activeElement;

    $('body').on('keyup', function (e) {
        if (e.which == 9) {
            activeEl = document.activeElement;
            var modalControlsJQ = $('.popup-promo-open, #interest-list-popup').has(activeEl);

            // If the tab is not on the modal, keep track of the focused element
            if (modalControlsJQ.length == 0) {
                newEl = activeEl;
            }
        }
    });

    showTheNextPopup();

    $('.popup-promo-open, #interest-list-popup').on('closed.zf.reveal', function () {
        if (activeEl.tagName.toLowerCase() === null || activeEl.tagName.toLowerCase() === 'body') {
            // set focus to the first element on the page   

            $('header').find('a:first').focus();

        } else {
            if (newEl === undefined || newEl === null) {
                $('header').find('a:first').focus();
            } else {
                // set focus to the current element
                newEl.focus();
            }
        }

        showTheNextPopup();
    });

    // KWM-2581/2582
    preventScrollOnClose($('.popup-promo-open'));
    preventScrollOnClose($('#interest-list-popup'));
});

function showTheNextPopup() {
    var popUpModule = $('.popup-promo-open');
    if (popUpModule.length) {
        popUpModule.each(function (index, value) {
            if (!thisIdExistInCache(value.id)) {
                setTimeout(function () {
                    OpenPopup(value);
                }, 3000);

                return false;
            }
        });
    }

    // all shown
    var allShown = allPopupPromosAreShownAndCached();
    if (allShown) { ShowInterestPopup(); }
}

function OpenPopup(value) {
    $("#" + value.id).foundation('open');
    // On Close save the id in the cookie
    document.cookie = value.id + "=" + "closed" + ";";
}

function thisIdExistInCache(popupId) {
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        // IE doesn't support trimLeft()
        if (ca[i].trim().startsWith(popupId)) {
            return true;
        }
    }
    return false;
}

function allPopupPromosAreShownAndCached() {
    var popUpModule = $('.popup-promo-open');
    var numAllPopupPromos = popUpModule.length;
    var cacheCount = 0;

    if (popUpModule.length) {
        popUpModule.each(function (index, value) {
            if (thisIdExistInCache(value.id)) {
                cacheCount++;
            }
        });
    }
    return (cacheCount === numAllPopupPromos);
}

function ShowInterestPopup() {
    // The community name should be dynamic
    var commName = "";
    if ($("#hidCommName").length) {
        commName = $("#hidCommName")[0].value;
    }
    $("#placeholderCommName").replaceWith("<p class=\"p-large cta-prompt\">Receive news and email updates about " + commName + ".</p>");

    var messageModalsWithDelay = $(".message-modal[data-message-modal-delay");
    if (messageModalsWithDelay) {
        
        messageModalsWithDelay.each(function (index, elem) {
            // This delay number should come from a field in back end
            if ($("#hidDelay").length > 0) {
                var hdnSec = ($("#hidDelay")[0].value == 0) ? 1 : $("#hidDelay")[0].value;
                $(elem).data("message-modal-delay", hdnSec * 1000);
            }
            var messageDelay = $(elem).data("message-modal-delay");
            if (messageDelay) {
                var messageDelayMs = parseInt(messageDelay);
                if (messageDelayMs > 0) {
                    if (!thisIdExistInCache("interest-list-popup")) {
                        setTimeout(function () {
                            $(elem).foundation('open');

                            // Show this once to the user
                            setCookie("interest-list-popup", "closed", 0, "/");

                        }, messageDelayMs)
                    }
                }
            }
        });
    }
}

function setCookie(name, value, expires, path) {
    value = escape(value);
    var theCookie = name + "=" + value +
        ((expires) ? "; expires=" + expires.toGMTString() : "") +
        ((path) ? "; path=" + path : "");
    document.cookie = theCookie;
}

function preventScrollOnClose(popup)
{
    if (popup)
    {
        popup.on("open.zf.reveal", function () {
            // after modal opens
            popup.__scrollTop = Math.max($('html').scrollTop(), $('body').scrollTop());
        });
        popup.on("closed.zf.reveal", function () {
            // after modal closes
            $('html, body').scrollTop(popup.__scrollTop);
        });
    }  
}
